import Collection_Base from 'collection/base';
import Model_User_Invitation from 'model/user_invitation';

export default Collection_Base.extend({
    model: Model_User_Invitation,

    comparator: function(a, b) {
        return a.get('time') >= b.get('time') ? -1 : 1;
    }
});